type SizeImage = 'l' | 'm' | 's' | 'thumbnail'

interface ICreateUrlMedia {
  id: string
  size?: SizeImage
}

export const createUrlMedia = ({ id, size = 'l' }: ICreateUrlMedia) => {
  return `https://media.wiggot.mx/${id}-${size}.jpg`
}

export const getOperationArray = (property: any) => {
  return [
    {
      active: property?.presaleActive,
      type: 'Preventa',
      price: property?.presalePrice,
      currency: property?.presaleCurrency,
      commisionActive: property?.presaleShareCommission,
      sharedCommission: property?.presaleSharedCommission
    },
    {
      active: property?.saleActive,
      type: 'Venta',
      price: property?.salePrice,
      currency: property?.saleCurrency,
      commisionActive: property?.saleShareCommission,
      sharedCommission: property?.saleSharedCommission
    },
    {
      active: property?.leaseActive,
      type: 'Renta',
      price: property?.leasePrice,
      currency: property?.leaseCurrency,
      commisionActive: property?.leaseShareCommission,
      sharedCommission: property?.leaseSharedCommission
    }
  ]
}

export async function loadImageAsBlob(url: string): Promise<Blob> {
  return new Promise((resolve, reject) => {
    fetch(`/minisites/api/${encodeURIComponent(url)}`)
      .then((res) => res.blob())
      .then((blob) => resolve(blob))
      .catch((err: Error) => reject(err))
  })
}

export const ACCEPTED_IMAGE_TYPES = [
  'image/jpeg',
  'image/jpg',
  'image/png',
  'image/heic',
  'image/webp',
  ''
]
